import { Link } from "react-router-dom";
import { ShieldAlert, ArrowLeft } from "lucide-react";

export function NotFound({ to = "/", label = "Back to Vawworld", message }) {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center p-6" data-testid="not-found-page">
      <div className="max-w-md text-center">
        <div className="text-[10px] uppercase tracking-[0.4em] text-white/40">Error 404</div>
        <h1 className="mt-4 font-display font-black text-6xl md:text-8xl tracking-tighter leading-none">404</h1>
        <p className="mt-6 text-white/60 font-light">
          {message || "We couldn't find that. The studio may have moved, been suspended, or never existed."}
        </p>
        <Link
          to={to}
          className="mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-white/70 hover:text-white border border-white/15 hover:border-white/40 px-5 py-3"
          data-testid="not-found-home-link"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> {label}
        </Link>
      </div>
    </div>
  );
}

export function Forbidden() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center p-6" data-testid="forbidden-page">
      <div className="max-w-md text-center">
        <ShieldAlert className="w-10 h-10 mx-auto text-red-400" />
        <div className="mt-6 text-[10px] uppercase tracking-[0.4em] text-white/40">Error 403</div>
        <h1 className="mt-2 font-display font-black text-5xl md:text-6xl tracking-tighter leading-none">Forbidden</h1>
        <p className="mt-6 text-white/60 font-light">
          You're signed in, but not for this section. If you believe this is a mistake, sign in
          with the right account.
        </p>
        <Link
          to="/login"
          className="mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-white/70 hover:text-white border border-white/15 hover:border-white/40 px-5 py-3"
          data-testid="forbidden-login-link"
        >
          Sign in
        </Link>
      </div>
    </div>
  );
}
